import React, {lazy} from "react";
import {routes} from "../utils/routes";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import GroupIcon from '@mui/icons-material/Group';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BackupIcon from '@mui/icons-material/Backup';

export interface IRouteConfig {
    icon?: React.ReactNode;
    path: string;
    element: React.ReactNode;
    label: string; // Название для меню
    showInMenu?: boolean; // Показывать в меню или нет
    showInDownMenu?: boolean; // Показывать в меню или нет
    requiresAuth?: boolean;
    requiresAdmin?: boolean;
    /** Роут виден только пользователям с role_id из списка (см. models/IUser). */
    requiresRoles?: number[];
    /**
     * Роут рендерится ВНЕ оболочки приложения — без SideMenu, AppNavbar и
     * уведомлений, до всякой проверки авторизации.
     *
     * Нужен публичным страницам по токену: у них собственный layout, и
     * посетитель не должен видеть навигацию по чужому кабинету, даже если в
     * этой вкладке остался чей-то access_token (см. App.tsx).
     */
    standalone?: boolean;
    children?: IRouteConfig[];
}

// Каждая страница — отдельный чанк
const BoardPage = lazy(() => import("../features/board/ui/BoardPage"));
const StatsPage = lazy(() => import("../features/stats/ui/StatsPage"));
// «Оповещения» (MAX) скрыты до токена бота (S2.1): страница features/companies/ui/NotificationsPage и бэкенд остаются.
const LoginForm = lazy(() => import("../features/auth/ui/LoginForm"));
const RegisterForm = lazy(() => import("../features/auth/ui/RegisterForm"));
const Profile = lazy(() => import("../features/auth/ui/Profile"));
const UsersPage = lazy(() => import("../features/users/ui/UsersPage"));
const EcuRefsPage = lazy(() => import("../features/ecu/EcuRefsPage"));
const BackupPage = lazy(() => import("../features/backup/ui/BackupPage"));

export const routesConfig: IRouteConfig[] = [
    {
        icon: <ViewKanbanIcon/>,
        path: routes.machines,
        element: <BoardPage/>,
        label: "Доска",
        showInMenu: true,
        requiresAuth: true,
    },
    {
        icon: <QueryStatsIcon/>,
        path: routes.stats,
        element: <StatsPage/>,
        label: "Стата",
        showInMenu: true,
        requiresAuth: true,
    },
    {
        icon: <GroupIcon/>,
        path: routes.users,
        element: <UsersPage/>,
        label: "Сотрудники",
        showInMenu: true,
        requiresAuth: true,
    },
    {
        icon: <FactCheckIcon/>,
        path: routes.references,
        element: <EcuRefsPage/>,
        label: "Эталоны",
        showInMenu: true,
        requiresAuth: true,
    },
    {
        icon: <BackupIcon/>,
        path: routes.backups,
        element: <BackupPage/>,
        label: "Бэкапы",
        showInMenu: true,
        requiresAuth: true,
    },
    {
        icon: <HomeRoundedIcon/>,
        path: routes.login,
        element: <LoginForm/>,
        label: "Вход",
        showInMenu: false,
        requiresAuth: false,
    },
    {
        icon: <HomeRoundedIcon/>,
        path: routes.register,
        element: <RegisterForm/>,
        label: "Регистрация",
        showInMenu: false,
        requiresAuth: false,
    },
    {
        icon: <HomeRoundedIcon/>,
        path: routes.profile,
        element: <Profile/>,
        label: "Профиль",
        showInMenu: false,
        requiresAuth: true,
    },
];
